<script>
  import { inertia, page, router } from '@inertiajs/svelte';
  import Icon from '@iconify/svelte';
  import Flash from './Flash.svelte';

  let { title = '', children } = $props();

  let account = $derived(page.props.auth?.account);
  let current = $derived(page.url);

  const nav = [
    { href: '/admin', label: 'Overview', icon: 'mdi:gauge' },
    { href: '/admin/accounts', label: 'Accounts', icon: 'mdi:account-cog-outline' },
    { href: '/admin/outstand_accounts', label: 'Outstand', icon: 'mdi:link-variant' },
  ];

  function isActive(href) {
    return href === '/admin' ? current === '/admin' : current.startsWith(href);
  }

  function logout() {
    router.post('/auth/logout');
  }
</script>

<svelte:head><title>{title ? `${title} · Admin · neosocialmix` : 'Admin · neosocialmix'}</title></svelte:head>

<div class="min-h-screen">
  <div class="bg-amber-400 text-amber-950 text-xs font-display text-center py-1 tracking-widest uppercase">
    Admin area
  </div>
  <header class="bg-primary-950 text-secondary-50 border-b-2 border-primary-900">
    <div class="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between">
      <div class="flex items-center gap-8">
        <a use:inertia href="/admin" class="flex items-center gap-2 font-display text-xl tracking-tight">
          <Icon icon="mdi:shield-crown-outline" class="text-amber-400" />
          Admin
        </a>
        <nav class="flex items-center gap-1">
          {#each nav as item}
            <a
              use:inertia
              href={item.href}
              class="flex items-center gap-2 px-3 py-2 rounded text-sm font-medium transition-colors
                {isActive(item.href) ? 'bg-white/10 text-white' : 'text-secondary-300 hover:bg-white/5'}"
            >
              <Icon icon={item.icon} />
              {item.label}
            </a>
          {/each}
        </nav>
      </div>

      <div class="flex items-center gap-3 text-sm">
        <a use:inertia href="/" class="text-secondary-300 hover:text-white flex items-center gap-1">
          <Icon icon="mdi:arrow-left" /> Back to app
        </a>
        {#if account}
          <span class="text-secondary-500 hidden sm:inline">{account.email}</span>
          <button onclick={logout} aria-label="Sign out" class="text-secondary-300 hover:text-red-400 flex items-center gap-1">
            <Icon icon="mdi:logout" /> Sign out
          </button>
        {/if}
      </div>
    </div>
  </header>

  <main class="max-w-5xl mx-auto px-6 py-8">
    {#if title}
      <h1 class="text-hierarchy-1 ink-underline mb-6">{title}</h1>
    {/if}
    <Flash />
    {@render children?.()}
  </main>
</div>
